// useChatDetail (issue #419) — single chat + viewer's participant row.
//
// Reads `GET /chats/:chatId`. The controller wraps the row in
// `{ chat, lastMessagePreview, ... }` via `enrichThread` (authoritative
// shape: `backend/src/test/integration/chats-rest-surface.spec.ts`), so the
// hook resolves to a typed `ChatDetailEnvelope` — the enriched chat plus its
// side fields. Consumers read `data.chat` for the chat and the preview off
// the envelope directly.

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getChatDetail, ChatDetailEnvelope } from './api';
import { chatKeys } from './keys';

export function useChatDetail(
  chatId: number | undefined,
  options?: UseQueryOptions<ChatDetailEnvelope>
) {
  return useQuery<ChatDetailEnvelope>(
    chatKeys.chat(chatId ?? 0),
    () => getChatDetail(chatId as number),
    {
      enabled: typeof chatId === 'number' && chatId > 0,
      ...options,
    }
  );
}
